import Message from 'owa-service/lib/contract/Message';
import messageType from 'owa-service/lib/factory/message';
import MessageDetails from '../schema/MessageDetails';
import bodyContentType from 'owa-service/lib/factory/bodyContentType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function constructMessageFromDetails(messageDetails: MessageDetails): Message {
    let { subject, message, to } = messageDetails;
    const { SessionSettings: { UserEmailAddress = undefined } = {} } = getUserConfiguration();

    return messageType({
        Body: bodyContentType({ BodyType: 'HTML', Value: message }),
        Subject: subject,
        ToRecipients: to.map(alias => ({
            EmailAddress: alias,
        })),
        CcRecipients: [
            {
                EmailAddress: UserEmailAddress,
            },
        ],
        BccRecipients: [],
    });
}
